import { CheckoutCardConfig, CheckoutConfig } from '@checkout/util-models';

export const checkoutCardConfigFactory = (
  checkoutConfig: CheckoutConfig
): CheckoutCardConfig | undefined => checkoutConfig.card;
